import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { appUrl } from '../../utils'

const OficinaTabs = () => {
  const history = useHistory()
  const location = useLocation()
  const path = (location.pathname || '').toLowerCase()
  const isMisTickets = path.includes('mis-tickets')
  const isProductos = path.includes('productos') && !path.includes('compra-productos')
  const isCompraProductos = path.includes('compra-productos')

  const tabClass = (active) =>
    `oficina-tab px-4 py-2 rounded-pill text-decoration-none d-inline-flex align-items-center ${active ? 'oficina-tab--active' : 'oficina-tab--inactive'}`

  return (
    <nav className="oficina-tabs mb-4" aria-label="Oficina del cliente">
      <div className="d-flex flex-wrap gap-2 p-2 rounded-3 oficina-tabs__container">
        <button
          type="button"
          className={tabClass(isMisTickets)}
          onClick={() => history.push(appUrl({ url: '/mis-tickets' }))}
          aria-current={isMisTickets ? 'page' : undefined}
        >
          <i className="fa fa-ticket-alt me-2" aria-hidden />
          Mis tickets
        </button>
        <button
          type="button"
          className={tabClass(isProductos)}
          onClick={() => history.push(appUrl({ url: '/productos' }))}
          aria-current={isProductos ? 'page' : undefined}
        >
          <i className="fa fa-box me-2" aria-hidden />
          Productos
        </button>
        <button
          type="button"
          className={tabClass(isCompraProductos)}
          onClick={() => history.push(appUrl({ url: '/compra-productos' }))}
          aria-current={isCompraProductos ? 'page' : undefined}
        >
          <i className="fa fa-shopping-bag me-2" aria-hidden />
          Compra de Productos
        </button>
      </div>
    </nav>
  )
}

export default OficinaTabs
